export default __webpack_public_path__ + "static/media/popular_veryDarkGrey.2280db34.svg";